import { Text } from '@cinch-labs/design-system'
import cx from 'classnames'
import React from 'react'

import skeletonStyles from '../skeleton.module.css'
import styles from './price.module.css'

const numberWithCommas = (x: number) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

const penceToPounds = (n: number) => Math.round(n / 100)

export interface PriceProps {
  price: number
  shouldShowCarsOnOfferTag?: boolean
  discountInPence?: number
  quoteRegularPaymentInPence?: number | null
  quoteType?: string | null
  isPending?: boolean
}

export const Price: React.FC<PriceProps> = ({
  price,
  shouldShowCarsOnOfferTag = false,
  discountInPence,
  quoteRegularPaymentInPence,
  isPending,
}) => {
  const fullPrice = `£${numberWithCommas(price)}`

  const renderCashPrice = () => (
    <Text
      element="span"
      fontSizeFixed="l"
      fontWeight="semibold"
      aria-label={`Cash price. ${fullPrice}.`}
      aria-describedby={discountInPence ? 'was-price' : undefined}
      className={cx({
        [skeletonStyles.base]: isPending,
        [skeletonStyles.active]: isPending,
      })}
    >
      {fullPrice}
    </Text>
  )

  const renderCashPriceAndWasPrice = () => {
    const discount = penceToPounds(discountInPence ?? 0)
    const wasPrice = `£${numberWithCommas(price + discount)}`

    return (
      <div>
        <Text
          element="span"
          id="was-price"
          data-testid="was-price"
          fontSizeFixed="xs"
          fontWeight="medium"
          aria-hidden={true}
          className={cx(styles.wasPrice, {
            [skeletonStyles.base]: isPending,
            [skeletonStyles.active]: isPending,
          })}
        >
          Was <s>{wasPrice}</s>
        </Text>

        {renderCashPrice()}
      </div>
    )
  }

  return (
    <div className={styles.priceContainer}>
      {shouldShowCarsOnOfferTag
        ? renderCashPriceAndWasPrice()
        : renderCashPrice()}
    </div>
  )
}

export default Price
